import React from 'react';
import PropTypes from 'prop-types';
import ThirdPartyOfferCard from '../../widgets/ThirdPartyOfferCard';
import { thirdPartyOffersConfigItems } from '../../../constants/GeneralConfiguration';
import './ThirdPartyOffersSection.scss';

class ThirdPartyOffersSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { openInfoCode: null };
        this.handleInfoToggle = this.handleInfoToggle.bind(this);
    }

    handleInfoToggle(code, nextIsOpen) {
        if (nextIsOpen) {
            this.setState({ openInfoCode: code });
            return;
        }

        this.setState(prev => ({ openInfoCode: prev.openInfoCode === code ? null : prev.openInfoCode }));
    }

    render() {
        const { currentConfigCopy, isDisabled, onToggle, registerSection, sectionStyleHandler } = this.props;
        const { openInfoCode } = this.state;

        return (
            <div className="third-party-offers">
                <h4>THIRD-PARTY OFFERS</h4>
                <p>
                    Activate the offers you want to display in your booking engine. To make the offers
                    available they must also be enabled in SynXis CRS.
                </p>
                {thirdPartyOffersConfigItems.map(offer => {
                    const sectionRef = 28 + offer.sectionRefOffset;
                    return (
                        <ThirdPartyOfferCard
                            key={offer.code}
                            offer={offer}
                            value={Boolean(currentConfigCopy[offer.code])}
                            isDisabled={isDisabled}
                            onToggle={onToggle}
                            cardRef={registerSection(sectionRef)}
                            cardStyle={sectionStyleHandler(sectionRef)}
                            isInfoOpen={openInfoCode === offer.code}
                            onInfoToggle={nextIsOpen => this.handleInfoToggle(offer.code, nextIsOpen)}
                        />
                    );
                })}
            </div>
        );
    }
}

ThirdPartyOffersSection.propTypes = {
    currentConfigCopy: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    registerSection: PropTypes.func.isRequired,
    sectionStyleHandler: PropTypes.func.isRequired,
};

export default ThirdPartyOffersSection;


// WEBPACK FOOTER //
// ./src/components/pages/sections/ThirdPartyOffersSection.js